export default __webpack_public_path__ + "a36fbf4e69a99efdd1cac1d455a3d550.svg";